import AssetTypes from './asset_types';
import AssetTypeEdit from './asset_type_edit';
import AssetTypeAdd from './asset_type_add';
import AssetTypeView from './asset_type_view';

export {
  AssetTypes,
  AssetTypeEdit,
  AssetTypeAdd,
  AssetTypeView
};
